import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
// import LazyLoad from 'react-lazy-load';
import NewsletterForm from '../../components/newletter-form'
import { RichText } from 'prismic-reactjs'
import LinkResolver from '../../link-resolver'

const Elements = RichText.Elements;

// -- Function to add unique key to props
const propsWithUniqueKey = function (props, key) {
	return Object.assign(props || {}, { key });
};


// -- HTML Serializer
const htmlSerializer = function (type, element, content, children, key) {

	var props = {};

	switch (type) {

		case Elements.hyperlink: // Image
			const targetAttr = { target: '_blank' };
			const relAttr = element.data.target ? { rel: 'noopener' } : {};
			props = Object.assign({
				href: element.data.url || LinkResolver(element.data)
			}, targetAttr, relAttr);
			return React.createElement('a', propsWithUniqueKey(props, key), children);

		default: // Always include a default that returns null
			return null;
	}
};
// import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

class StoreDetailPage extends Component {
	initialRows = 3;

	constructor() {
		super()
		this.state = { rows: this.initialRows, showMoreProducts: false }
	}

	componentDidMount() {
		// Forces Webflow animations to load
		setTimeout(() => {
			window.Webflow && window.Webflow.destroy();
			window.Webflow && window.Webflow.ready();
			window.Webflow && window.Webflow.require('ix2').init();
		}, 1000)
	}

	componentDidUpdate() {
		setTimeout(() => {
			window.Webflow && window.Webflow.destroy();
			window.Webflow && window.Webflow.ready();
			window.Webflow && window.Webflow.require('ix2').init();
		}, 1000)
	}

	render() {
		const store = this.props.store;
		const coverCSS = {
			backgroundImage: 'url(' + store.details.cover + ')'
		};
		const titleCSS = {
			textTransform: 'uppercase',
			color: store.color
		};

		// const rowCountProducts = Math.ceil((store.products.length) / 4.0);
		// const canLoadMore = store.products.length > (this.state.rows * 4 )
		// console.log('Teste:', store.details.description)
		// var blockLazy = (/blocklazy/gi).test(window.location.href);

		console.log("url", store.details.video)


		let allProducts = {}
		for (let i in store.products) {
			if (store.products[i].type) {
				if (!allProducts[store.products[i].type]) {
					allProducts[store.products[i].type] = []
				}
				allProducts[store.products[i].type].push(store.products[i])
			}
		}
		console.log(allProducts)

		var sc = document.createElement("script");
		sc.setAttribute("type", "application/ld+json");
		sc.text = `
				{
					  "@context": "http://schema.org",
	                  "@type": "BookStore",
	                  "parentOrganization": {
	                        "name" : "Startup Guide"
	                  },
	                  "name": "Startup Guide Store ` + store.name + `",
	                  "image": "`+ (store.social.generic[0] && store.social.generic[0].image ? store.social.generic[0].image : store.details.cover) + `",
	                  "@id": "https://startupguide.com/stores/` + store.slug + `",
	                  "url": "https://startupguide.com/stores/` + store.slug + `",
	                  "telephone": "`+ store.details.phone + `",
	                  "priceRange": "`+ store.structured_data.price_range + `",
	                  "address": {
	                        "@type": "PostalAddress",
	                        "streetAddress": "`+ store.structured_data.street_address + `",
	                        "addressLocality": "`+ store.structured_data.address_locality + `",
	                        "postalCode": "`+ store.structured_data.postal_code + `",
	                        "addressCountry": "`+ store.structured_data.address_country + `"
	                  },
	                  "geo": {
	                        "@type": "GeoCoordinates",
	                        "latitude": `+ store.structured_data.geo.latitude + `,
	                        "longitude": `+ store.structured_data.geo.longitude + `
	                  },
	        `;

		let letstoreurl = ""
		switch (store.slug) {
			case 'lisbon':
				letstoreurl = 'https://goo.gl/maps/7gfGjw7epJ9Q1LBu6'
				break;
			case 'copenhagen':
				letstoreurl = 'https://g.page/startup-guide-store-copenhagen?share'
				break;
			case 'berlin':
				letstoreurl = 'https://goo.gl/maps/rcHPsyWJmPz6dBdz7'
				break;
			default:
		}
		if (store.structured_data.openingHours.length === 1) {
			sc.text += `
	         		    "openingHoursSpecification": 
	          	`
		} else if (store.structured_data.openingHours.length > 1) {
			sc.text += `
	         		"openingHoursSpecification": [
	          	`
		}

		for (let i in store.structured_data.openingHours) {
			sc.text += `{
	                        "@type": "OpeningHoursSpecification",
	                        "dayOfWeek": `+ JSON.stringify(store.structured_data.openingHours[i].days_of_week) + `,
	                        "opens": "`+ store.structured_data.openingHours[i].open + `",
	                        "closes": "`+ store.structured_data.openingHours[i].close + `"
	                  }`
			if (i < (store.structured_data.openingHours.length - 1) || store.structured_data.openingHours.length === 1) {
				sc.text += `,`
			}
		}
		if (store.structured_data.openingHours.length > 1) {
			sc.text += `],`
		}
		sc.text += `
	                  "sameAs": "`+ store.structured_data.same_as + `"
	            }
            `
		document.head.appendChild(sc);

		return (
			<div>
				<Helmet>
					<title>Startup Guide - {store.seo.title ? store.seo.title : store.name + ' Store'}</title>
					<meta name="description" content={store.seo.description ? store.seo.description : store.name + " store"}></meta>

					<meta property="og:title" content={(store.social.generic[0] && store.social.generic[0].title) ? store.social.generic[0].title : store.name}></meta>
					<meta property="og:description" content={store.social.generic[0] && store.social.generic[0].description ? store.social.generic[0].description : store.name + " store"}></meta>
					<meta property="og:image" content={store.social.generic[0] && store.social.generic[0].image ? store.social.generic[0].image : store.details.cover}></meta>
					<meta property="og:url" content={"https://startupguide.com/stores/" + store.slug}></meta>
					<meta property="og:type" content="website"></meta>
					<meta property="og:site_name" content="StartupGuide"></meta>

					<meta name="twitter:card" content={store.social.twitter[0] && store.social.twitter[0].type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
					<meta name="twitter:site" content="@StartupGuideHQ"></meta>
					<meta name="twitter:creator" content={store.social.twitter[0] && store.social.twitter[0].handle ? store.social.twitter[0].handle : '@StartupGuideHQ'}></meta>
					<meta name="twitter:title" content={store.social.twitter[0] && store.social.twitter[0].title ? store.social.twitter[0].title : store.name}></meta>
					<meta name="twitter:description" content={store.social.twitter[0] && store.social.twitter[0].description ? store.social.twitter[0].description : store.name + " store"}></meta>
					<meta name="twitter:image" content={store.social.twitter[0] && store.social.twitter[0].image ? store.social.twitter[0].image : store.details.cover}></meta>
				</Helmet>
				<div id="start" className="page-title" style={coverCSS}></div>
				<div className="store-intro">
					<div className="berlin---store---intro">
						<div className="text-block-112" style={titleCSS}>{store.name}</div>
						<div className="w-row">
							<div className="column-23 w-col w-col-9 w-col-medium-6">
								<div className="store-description">{RichText.render(store.details.description, LinkResolver, htmlSerializer)}</div>
							</div>
							<div className="column-24 w-col w-col-3 w-col-medium-6">
								<div className="office-info">
									<div className="text-block-108-copy">Say hello!</div>
									<div className="div-block-151"><img src="/images/location-pin.svg" width="22" alt="" className="image-112" />
										<div className="text-block-109"><a target="_blank" href={letstoreurl} className="link-21">{store.preview.address}</a></div>
									</div>
									<div className="div-block-151"><img src="/images/open-times.svg" width="22" alt="" className="image-112" />
										<div className="text-block-110">{store.details.operatinghours}</div>
									</div>
									<div className="div-block-151"><img src="/images/contact.svg" width="22" alt="" className="image-112" />
										<div><a href={"tel:" + store.details.phone} className="phonenumber">{store.details.phone}</a></div>
									</div>
									<div className="div-block-151"><img src="/images/mail.svg" width="22" alt="" className="image-112" />
										<div><a href={"mailto:" + store.details.email} className="link-21">{store.details.email}</a></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="products" className="stores-description grid-store-description">
					<div className="description-stores">
						<div className="stores-description-row w-row productTableColumns" style={{ marginTop: '0px' }}>
							<div className="stores-description-column-left w-col w-col-12">
								<div>
									<blockquote className="p-blockquote-copy" style={{ maxWidth: "570px" }}>We're stockists for global magazines and books Find your favorites paper products in our stores.</blockquote>
									<div className="row-grid-product" style={{
										maxHeight: !this.state.showMoreProducts ? '280px' : 'unset',
									}}>
										<span><strong>Indie Magazines</strong></span>
										{allProducts['Indie Magazines'] && allProducts['Indie Magazines'].map((p, k) =>
											<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
										)}
									</div>
								</div>
							</div>
						</div>
						<div key="showmore" className="button-show-more-products">
							<a
								data-w-id="72028f29-0ac2-fd2f-c466-6ae180529edb"
								className="discover-more-category busines w-button"
								style={{
									background: '#e1e1e1',
									color: '#7E7E7E',
									border: 0,
									display: !this.state.showMoreProducts ? 'block' : 'none',
								}}
								onClick={() => this.setState({ showMoreProducts: true })}
							>
								SHOW&nbsp;MORE
							</a>
						</div>
						<div className="stores-description-row w-row productTableColumns" style={{ marginTop: 10, alignItems: 'flex-start' }}>
							<div className="stores-description-column-left w-col w-col-4" style={{ paddingTop: '50px', marginRight: '10px' }}>
								<div className="row-grid-product" style={{ maxHeight: 'none' }}>
									<span><strong>Books</strong></span>
									{allProducts['Books, Notebooks and Agendas'] && allProducts['Books, Notebooks and Agendas'].map((p, k) =>
										<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
									)}
								</div>
							</div>
							<div className="stores-description-column-left w-col w-col-2" style={{ paddingTop: '50px', marginRight: '10px' }}>
								<div className="row-grid-product" style={{ maxHeight: 'none' }}>
									<span><strong>Games</strong></span>
									{allProducts['Cards & Games'] && allProducts['Cards & Games'].map((p, k) =>
										<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
									)}
								</div>
							</div>
							<div className="stores-description-column-left w-col w-col-4">
							</div>
							<div className="stores-description-column-left w-col w-col-4">
								<img src="/images/store-books.png" width="437" sizes="(max-width: 479px) 216.9375px, (max-width: 991px) 46vw, 437px" alt="" className="image-108" />
							</div>
						</div>
					</div>
				</div>

				<div className="store-gallery">
					<div data-delay="4000" data-animation="slide" data-autoplay="1" data-nav-spacing="4" data-duration="500" data-infinite="1" className="slider-3 w-clearfix w-slider">
						<div className="mask w-slider-mask">
							{
								store.details.gallery.map(
									(p, k) =>
										<div key={k} className="store-gallery-slider w-clearfix w-slide">
											<img src={p} alt="" className="store-gallery-slider-image" />
										</div>
								)
							}
						</div>
						<div className="w-slider-arrow-left">
							<div className="w-icon-slider-left"></div>
						</div>
						<div className="w-slider-arrow-right">
							<div className="w-icon-slider-right"></div>
						</div>
						<div className="slide-nav-2 w-slider-nav w-round"></div>
					</div>
				</div>

				{store.slug === 'lisbon' && store.details.video &&
					<div className="store-video">
						<div className="video-store">
							<div style={{ paddingTop: '56.17021276595745%' }} id="w-node-5074a0638d58-b35046fd" className="w-video w-embed">
								<iframe title="store-video" className="embedly-embed" src={store.details.video} scrolling="no" frameBorder="0" allowFullScreen=""></iframe>
							</div>
						</div>
					</div>
				}


				<div className="buttons-container-stores w-clearfix" style={{ paddingTop: '50px', paddingBottom: '50px' }}>
					<a href={"/stores#start"} className="button small secondary margin-right-16px w-inline-block w-clearfix">
						<div className="text-block-3" style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>See All Locations <img src="/images/ARROW-F.svg" height="16" width="16" alt="" className="icon _16px black" /></div>
					</a>
				</div>

				<div id="events" className="store-events">
					<div className="berlin-row-events-store">
						<h1 className="page-subtitle left margin-bottom-32px">Next events at our store</h1>
						<div className="events-row w-row">
							<div className="column-5 w-col w-col-3 w-col-medium-6">
								<div>
									<div className="event-image">
										<div className="event-price nested">
											<div className="category-name">From €100</div>
										</div><img src="/images/image-19-9-placeholder.svg" alt="" className="image-event" /></div>
									<div className="w-row">
										<div className="w-col w-col-3 w-col-small-3">
											<div className="div-block-44 stores">
												<h5 className="event-date-time margin-top-16px margin-bottom-8px">SET<br /></h5>
												<h5 className="event_day">30<br /></h5>
											</div>
										</div>
										<div className="w-col w-col-9 w-col-small-9">
											<h3 className="event-title">droidcon Berlin 2018</h3>
											<div className="div-block-45"><img src="/images/grey_time.svg" width="16" alt="" className="image-36" />
												<div className="place">Sunday, September 30, 8:00 am</div>
											</div>
											<div className="div-block-45"><img src="/images/place.svg" width="14" alt="" className="location" />
												<div className="place">Funkhaus Berlin</div>
											</div>
											<div className="div-block-45">
												<div className="tags">#tags #tags #tags</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="column-2 w-col w-col-3 w-col-medium-6">
								<div>
									<div className="event-image">
										<div className="event-price nested">
											<div className="category-name">Free</div>
										</div><img src="/images/image-19-9-placeholder.svg" alt="" className="image-event" /></div>
									<div className="w-row">
										<div className="w-col w-col-3 w-col-small-3">
											<div className="div-block-44">
												<h5 className="event-date-time margin-top-16px margin-bottom-8px">APR<br /></h5>
												<h5 className="event_day">14<br /></h5>
											</div>
										</div>
										<div className="w-col w-col-9 w-col-small-9">
											<h3 className="event-title">Stuff happening in Berlin</h3>
											<div className="div-block-45"><img src="/images/grey_time.svg" width="16" alt="" className="image-36" />
												<div className="place">Sunday, September 30, 8:00 am</div>
											</div>
											<div className="div-block-45"><img src="/images/place.svg" width="14" alt="" className="location" />
												<div className="place">Funkhaus Berlin</div>
											</div>
											<div className="div-block-45">
												<div className="tags">#tags #tags #tags</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="column-7 w-col w-col-3 w-col-medium-6">
								<div>
									<div className="event-image">
										<div className="event-price nested">
											<div className="category-name">From <strong>€</strong>50</div>
										</div><img src="/images/image-19-9-placeholder.svg" alt="" className="image-event" /></div>
									<div className="w-row">
										<div className="w-col w-col-3 w-col-small-3">
											<div className="div-block-44">
												<h5 className="event-date-time margin-top-16px margin-bottom-8px">OUT<br /></h5>
												<h5 className="event_day">22<br /></h5>
											</div>
										</div>
										<div className="w-col w-col-9 w-col-small-9">
											<h3 className="event-title">droidcon Berlin 2018</h3>
											<div className="div-block-45"><img src="/images/grey_time.svg" width="16" alt="" className="image-36" />
												<div className="place">Sunday, September 30, 8:00 am</div>
											</div>
											<div className="div-block-45"><img src="/images/place.svg" width="14" alt="" className="location" />
												<div className="place">Funkhaus Berlin</div>
											</div>
											<div className="div-block-45">
												<div className="tags">#tags #tags #tags</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="column-8 w-col w-col-3 w-col-medium-6">
								<div>
									<div className="event-image">
										<div className="event-price nested">
											<div className="category-name">From <strong>€</strong>99,99 </div>
										</div><img src="/images/image-19-9-placeholder.svg" alt="" className="image-event" /></div>
									<div className="w-row">
										<div className="w-col w-col-3 w-col-small-3">
											<div className="div-block-44">
												<h5 className="event-date-time margin-top-16px margin-bottom-8px">SET<br /></h5>
												<h5 className="event_day">30<br /></h5>
											</div>
										</div>
										<div className="w-col w-col-9 w-col-small-9">
											<h3 className="event-title">droidcon Berlin 2018</h3>
											<div className="div-block-45"><img src="/images/grey_time.svg" width="16" alt="" className="image-36" />
												<div className="place">Sunday, September 30, 8:00 am</div>
											</div>
											<div className="div-block-45"><img src="/images/place.svg" width="14" alt="" className="location" />
												<div className="place">Funkhaus Berlin</div>
											</div>
											<div className="div-block-45">
												<div className="tags">#tags #tags #tags</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="buttons-container centered more-events"><a className="discover-more-events w-button">MORE EVENTS IN BERLIN</a></div>
					</div>
				</div>
				<NewsletterForm />
			</div>
		);
	}
}

export default StoreDetailPage;